import { Component, Input, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SenderEmailModel } from 'app/models/sender-email-model';
import { SenderSMSModel } from 'app/models/sender-sms-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { filter } from 'rxjs';


@Component({
  selector: 'app-admin-sender',
  templateUrl: './admin-sender.page.html',
  styleUrls: ['./admin-sender.page.scss'],
})
export class AdminSenderPage implements OnInit {

  @Input() data:string;
  selectedTabIndex = 0;
  
  senderEmails: {
    content: SenderEmailModel[],
    pageNumber: number,
    totalElements: number,
    size: number,
    last: boolean
  } = { totalElements: 50, size:0, pageNumber: 0, last: false, content: [] };

  senderSMSs: {
    content: SenderSMSModel[],
    pageNumber: number,
    totalElements: number,
    size: number,
    last: boolean
  } = { totalElements: 50, size:0, pageNumber: 0, last: false, content: [] };
  emailDisplayedColumns: string[] = ['id', 'from', 'to', 'subject', 'createdAt'];
  smsDisplayedColumns: string[] = ['id', 'from', 'to', 'body', 'createdAt'];

  constructor(    
    private restService: RestService,
    public appService: AppService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.getEmailSenders();
    this.getSMSSenders();
  }

  onTabChange(index: number) {
    this.selectedTabIndex = index;
  }

  refreshCurrentTab() {
    if (this.selectedTabIndex === 1) {
      this.getSMSSenders();
      return;
    }

    this.getEmailSenders();
  }

  emailDetail(sender: SenderEmailModel) {
    this.dialog.open(SenderEmailModalContent, {
      panelClass: 'responsive-dialog',
      maxWidth: '95vw',
      data: { sender, isNew: sender.id == undefined }
    });
  }


  smsDetail(sender: SenderSMSModel) {
    this.dialog.open(SenderSmsModalContent, {
      panelClass: 'responsive-dialog',
      maxWidth: '95vw',
      data: { sender, isNew: sender.id == undefined }
    });
  }

  getEmailSenders(){
    let filter = this.data ? '&filters=data;EQUALS;'+this.data : '';
    let sort = '&sort=createdAt,desc';
    let pageSize = "&page=" + this.senderEmails.pageNumber + '&size=' + this.senderEmails.totalElements + filter;
    this.restService.getSenderEmails(sort + pageSize).subscribe(result => {
      //console.log('getSenders', result);
      this.senderEmails = result;
    });
  }


  getSMSSenders(){
    let filter = this.data ? '&filters=data;EQUALS;'+this.data : '';
    let sort = '&sort=createdAt,desc';
    let pageSize = "&page=" + this.senderSMSs.pageNumber + '&size=' + this.senderSMSs.totalElements + filter;
    this.restService.getSenderSMSs(sort + pageSize).subscribe(result => {
      //console.log('getSenders', result);
      this.senderSMSs = result;
    });
  }

  
    /**
     * 
     * @param event example: { length: 155, pageIndex: 1, pageSize: 50, previousPageIndex: 0 }
     */
    onPageChangeEmail(event: PageEvent) {
        console.log(event);
        this.senderEmails.pageNumber = event.pageIndex;
        this.senderEmails.totalElements = event.pageSize;
        this.getEmailSenders();
    }

    onPageChangeSMS(event: PageEvent) {
        console.log(event);
        this.senderSMSs.pageNumber = event.pageIndex;
        this.senderSMSs.totalElements = event.pageSize;
        this.getSMSSenders();
    }

}


@Component({
  selector: 'app-sender-email-modal-content',
  templateUrl: './sender-email-modal.component.html',
  styleUrls: ['./admin-sender.page.scss']
})
export class SenderEmailModalContent {
  sender: SenderEmailModel;
  isNew: boolean;

  constructor(public activeModal: MatDialogRef<SenderEmailModalContent>,
              @Inject(MAT_DIALOG_DATA) public data: { sender: SenderEmailModel; isNew: boolean },
              private restService: RestService,
              public appService: AppService) {
                this.sender = data?.sender;
                this.isNew = data?.isNew;
              }

             
 
  cancel() {
      this.activeModal.close();
  }

  openTicket(){
    let newWindow = window.open("")
    newWindow.document.write(this.sender.htmlBody);
  }


}


@Component({
  selector: 'app-sender-sms-modal-content',
  templateUrl: './sender-sms-modal.component.html',
  styleUrls: ['./admin-sender.page.scss']
})
export class SenderSmsModalContent {
  sender: SenderSMSModel;
  isNew: boolean;

  constructor(public activeModal: MatDialogRef<SenderSmsModalContent>,
              @Inject(MAT_DIALOG_DATA) public data: { sender: SenderSMSModel; isNew: boolean },
              private restService: RestService,
              public appService: AppService) {
                this.sender = data?.sender;
                this.isNew = data?.isNew;
              }

             
 
  cancel() {
      this.activeModal.close();
  }


}
